exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui-datatable .ui-datatable-data>tr>td {\n    padding: .6rem 2rem;\n    background-color: #186ba0;\n}\n\n.footer-align-left {\n    text-align: left !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/processes/process.component.css
// module id = 1920
// module chunks = 0